/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Config_Error_SaveInputs */



/**
* | output |
* | --- |
* | "Failed to save" |
*
* @param {Config_Error_SaveInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const config_error_save = /** @type {((inputs?: Config_Error_SaveInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Config_Error_SaveInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec de l'enregistrement")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error al guardar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Falha ao salvar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salvataggio fallito")
	return /** @type {LocalizedString} */ ("Failed to save")
});